// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("font/poppins-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("font/poppins-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("font/poppins-extralight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("font/poppins-extralight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("font/poppins-thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("font/poppins-thin.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --brand-purple: #401541;
    --brand-purple-transparent: #40154177;
    --dark-brand-purple: #1f0d21;
    --transparent-black: #00000088;
    font-family: 'Poppins', 'Helvetica', 'Aptos', sans-serif;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 20px;
}

body {
    background: -webkit-gradient(linear, top, bottom, from(#401541), to(#29112b)) fixed;
    min-height: 100%;
    height: 100dvh;
    max-width: 100%;
    width: 100dvw;
    display: flex;
    flex-direction: column;
}

/*@font-face {
    font-family: 'Poppins';
}*/

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 200;
    font-style: normal;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-weight: 100;
    font-style: normal;
}

header, footer {
    color: #fff;
}

#gradient-mask {
    position: fixed;
    width: 100vw;
    height: 30px;
    z-index: 2;
    background: linear-gradient(to bottom, #3e1d40 20%, #3e194088, #0000);
}

#gradient-bg {
    position: fixed;
    top: 0px;
    z-index: -1;
    width: 100dvw;
    height: 100dvh;
    background-image: linear-gradient(to bottom, #3e1d40 10%, #2a182b 40%, #1d0d1f 70%, #110712);
}

.sticky-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

header {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    cursor: default;
    align-self: stretch;
    z-index: 1;
    background: linear-gradient(to bottom, #3e1d40 65%, #0000);

    h1 {
        font-size: 2rem;
        font-weight: 400;
        padding: .5rem 1rem;
    }

}

footer {
    background-color: #000;
    margin-top: auto;
    padding: .6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 100;
    font-size: .8rem;
    color: #bbb;
    a {
        color: #ddd;
        margin-left: .5rem;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
            color: #fff;
        }
    }
}

#hatemail {
    margin-top: auto;
    font-weight: 400;
    font-size: .8rem;
    display: flex;
    flex-direction: row;
    gap: 0;
    align-self: flex-end;
    a {
        color: #ddd;
        text-decoration: none;
        &:hover {

            text-decoration: underline;
            color: #fff;
        }
    }

    .hatemail-label, .hatemail-link {
        padding: .7rem;
        display: inline;
    }

    .hatemail-label {
        background-color: #05050566;
        font-weight: 200;
    }

    .hatemail-link{
        background-color: #09090966;
        &:has(a:hover) {
            animation: linkHover .2s forwards;
        }
        a{
            color: #aaa;
            &:hover {
                color: #fff;
            }
        }
    }
}

#content {
    max-width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    color: #e1e1e1;
    padding: 2rem 1rem 1rem;

    #about {
        margin-top: -1rem;
        max-width: 34ch;
        text-align: center;
        padding: 1.5rem 1.8rem;
        color: #ccc;
        background: linear-gradient(to bottom, #0005, #0006);
        font-weight: 200;
        line-height: 120%;

        .spacer {
            display: none;
        }
    }
}

#profile-pic-container {

    img {
        width: 200px;
        aspect-ratio: 1/1;
        border-radius: 50%;
        object-fit: cover;
        opacity: .666;
        box-shadow: .3rem .7rem 1rem #0007;
        filter: saturate(55%) contrast(120%);
    }
}

#links {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: clamp(200px, 100%, 400px);
    margin-bottom: 3rem;

    a {
        text-decoration: none;
    }
}

.link-card {
    width: 100%;
    padding: .8rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    background-color: var(--transparent-black);
    cursor: pointer;
    border: none;

    span {
        text-decoration: none;
        text-transform: lowercase;
        color: #ccc;
        font-size: 1.1rem;
        font-weight: 400 !important;
    }

    &.fade {
        background-color: #00000044;
        span {
            font-size: 1rem;
        }
    }

    .friendly-title, .url-title {
        position: absolute;
        margin-left: 2.5rem;
        display: inline
    }

    .friendly-title {
        opacity: 1;
        color: #bbb;
    }
    .url-title {
        opacity: 0;
        color: #fff;
    }

    &:hover {
        animation: linkHover .2s forwards;
        .friendly-title {
            animation: fadeOut .2s forwards;
        }
        .url-title {
            animation: fadeIn .2s forwards;
            color: #fff;
        }
    }

    svg {
        fill: #ddd;
        height: 30px;
        position: relative;
        margin-right: .3rem;
    }
}

.link-label {
    margin-top: -.4rem;
    margin-left: .5rem;
    font-size: .7rem;
    font-weight: 200;
    --defaultLinkOpacity: .7;
    opacity: var(--defaultLinkOpacity);
}

a:has(.link-card):hover + .link-label {
    animation: labelFadeIn .2s forwards;
}

a:has(.link-card):not(:hover) + .link-label {
    animation: labelFadeOut .2s forwards;
}

@keyframes linkHover {
    0% {
        background-color: inherit;
        color: white;
    }
    100% {
        background-color: #40154188;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: .8;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes labelFadeIn {
    100% {
        opacity: 1;
    }
}

@keyframes labelFadeOut {
    100% {
        opacity: var(--defaultLinkOpacity);
    }
}

@media (max-width: 500px) {
    header {
        padding-bottom: .5rem;
    }

    #links {
        width: 95%;

        .link-label {
            max-width: 65%;
            line-height: 120%;
            text-align: right;
            align-self: flex-end;
            margin-left: -.5rem;
            margin-right: .5rem;
        }
    }

    #about {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    #hatemail {
        align-self: center;
        margin-top: -2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,4BAA4B;IAC5B,8BAA8B;IAC9B,wDAAwD;IACxD,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mFAAmF;IACnF,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;EAEE;;AAEF;IACI,sBAAsB;IACtB;0DAC+C;IAC/C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;0DACkD;IAClD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;0DAC4C;IAC5C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,qEAAqE;AACzE;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,aAAa;IACb,cAAc;IACd,4FAA4F;AAChG;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,0DAA0D;;IAE1D;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX;QACI,WAAW;QACX,kBAAkB;QAClB,qBAAqB;QACrB;YACI,0BAA0B;YAC1B,WAAW;QACf;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,oBAAoB;IACpB;QACI,WAAW;QACX,qBAAqB;QACrB;;YAEI,0BAA0B;YAC1B,WAAW;QACf;IACJ;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B;YACI,iCAAiC;QACrC;QACA;YACI,WAAW;YACX;gBACI,WAAW;YACf;QACJ;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,uBAAuB;;IAEvB;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,oDAAoD;QACpD,gBAAgB;QAChB,iBAAiB;;QAEjB;YACI,aAAa;QACjB;IACJ;AACJ;;AAEA;;IAEI;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,kCAAkC;QAClC,oCAAoC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC;IAChC,mBAAmB;;IAEnB;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,0CAA0C;IAC1C,eAAe;IACf,YAAY;;IAEZ;QACI,qBAAqB;QACrB,yBAAyB;QACzB,WAAW;QACX,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;QAC3B;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,iCAAiC;QACjC;YACI,+BAA+B;QACnC;QACA;YACI,8BAA8B;YAC9B,WAAW;QACf;IACJ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;IAChB;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,UAAU;;QAEV;YACI,cAAc;YACd,iBAAiB;YACjB,iBAAiB;YACjB,oBAAoB;YACpB,mBAAmB;YACnB,mBAAmB;QACvB;IACJ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ","sourcesContent":[":root {\n    --brand-purple: #401541;\n    --brand-purple-transparent: #40154177;\n    --dark-brand-purple: #1f0d21;\n    --transparent-black: #00000088;\n    font-family: 'Poppins', 'Helvetica', 'Aptos', sans-serif;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    font-size: 20px;\n}\n\nbody {\n    background: -webkit-gradient(linear, top, bottom, from(#401541), to(#29112b)) fixed;\n    min-height: 100%;\n    height: 100dvh;\n    max-width: 100%;\n    width: 100dvw;\n    display: flex;\n    flex-direction: column;\n}\n\n/*@font-face {\n    font-family: 'Poppins';\n}*/\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('font/poppins-regular.woff2') format('woff2'),\n    url('font/poppins-regular.woff') format('woff');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('font/poppins-extralight.woff2') format('woff2'),\n    url('font/poppins-extralight.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('font/poppins-thin.woff2') format('woff2'),\n    url('font/poppins-thin.woff') format('woff');\n    font-weight: 100;\n    font-style: normal;\n}\n\nheader, footer {\n    color: #fff;\n}\n\n#gradient-mask {\n    position: fixed;\n    width: 100vw;\n    height: 30px;\n    z-index: 2;\n    background: linear-gradient(to bottom, #3e1d40 20%, #3e194088, #0000);\n}\n\n#gradient-bg {\n    position: fixed;\n    top: 0px;\n    z-index: -1;\n    width: 100dvw;\n    height: 100dvh;\n    background-image: linear-gradient(to bottom, #3e1d40 10%, #2a182b 40%, #1d0d1f 70%, #110712);\n}\n\n.sticky-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\nheader {\n    position: sticky;\n    top: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    cursor: default;\n    align-self: stretch;\n    z-index: 1;\n    background: linear-gradient(to bottom, #3e1d40 65%, #0000);\n\n    h1 {\n        font-size: 2rem;\n        font-weight: 400;\n        padding: .5rem 1rem;\n    }\n\n}\n\nfooter {\n    background-color: #000;\n    margin-top: auto;\n    padding: .6rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 100;\n    font-size: .8rem;\n    color: #bbb;\n    a {\n        color: #ddd;\n        margin-left: .5rem;\n        text-decoration: none;\n        &:hover {\n            text-decoration: underline;\n            color: #fff;\n        }\n    }\n}\n\n#hatemail {\n    margin-top: auto;\n    font-weight: 400;\n    font-size: .8rem;\n    display: flex;\n    flex-direction: row;\n    gap: 0;\n    align-self: flex-end;\n    a {\n        color: #ddd;\n        text-decoration: none;\n        &:hover {\n\n            text-decoration: underline;\n            color: #fff;\n        }\n    }\n\n    .hatemail-label, .hatemail-link {\n        padding: .7rem;\n        display: inline;\n    }\n\n    .hatemail-label {\n        background-color: #05050566;\n        font-weight: 200;\n    }\n\n    .hatemail-link{\n        background-color: #09090966;\n        &:has(a:hover) {\n            animation: linkHover .2s forwards;\n        }\n        a{\n            color: #aaa;\n            &:hover {\n                color: #fff;\n            }\n        }\n    }\n}\n\n#content {\n    max-width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n    color: #e1e1e1;\n    padding: 2rem 1rem 1rem;\n\n    #about {\n        margin-top: -1rem;\n        max-width: 34ch;\n        text-align: center;\n        padding: 1.5rem 1.8rem;\n        color: #ccc;\n        background: linear-gradient(to bottom, #0005, #0006);\n        font-weight: 200;\n        line-height: 120%;\n\n        .spacer {\n            display: none;\n        }\n    }\n}\n\n#profile-pic-container {\n\n    img {\n        width: 200px;\n        aspect-ratio: 1/1;\n        border-radius: 50%;\n        object-fit: cover;\n        opacity: .666;\n        box-shadow: .3rem .7rem 1rem #0007;\n        filter: saturate(55%) contrast(120%);\n    }\n}\n\n#links {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: clamp(200px, 100%, 400px);\n    margin-bottom: 3rem;\n\n    a {\n        text-decoration: none;\n    }\n}\n\n.link-card {\n    width: 100%;\n    padding: .8rem;\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    background-color: var(--transparent-black);\n    cursor: pointer;\n    border: none;\n\n    span {\n        text-decoration: none;\n        text-transform: lowercase;\n        color: #ccc;\n        font-size: 1.1rem;\n        font-weight: 400 !important;\n    }\n\n    &.fade {\n        background-color: #00000044;\n        span {\n            font-size: 1rem;\n        }\n    }\n\n    .friendly-title, .url-title {\n        position: absolute;\n        margin-left: 2.5rem;\n        display: inline\n    }\n\n    .friendly-title {\n        opacity: 1;\n        color: #bbb;\n    }\n    .url-title {\n        opacity: 0;\n        color: #fff;\n    }\n\n    &:hover {\n        animation: linkHover .2s forwards;\n        .friendly-title {\n            animation: fadeOut .2s forwards;\n        }\n        .url-title {\n            animation: fadeIn .2s forwards;\n            color: #fff;\n        }\n    }\n\n    svg {\n        fill: #ddd;\n        height: 30px;\n        position: relative;\n        margin-right: .3rem;\n    }\n}\n\n.link-label {\n    margin-top: -.4rem;\n    margin-left: .5rem;\n    font-size: .7rem;\n    font-weight: 200;\n    --defaultLinkOpacity: .7;\n    opacity: var(--defaultLinkOpacity);\n}\n\na:has(.link-card):hover + .link-label {\n    animation: labelFadeIn .2s forwards;\n}\n\na:has(.link-card):not(:hover) + .link-label {\n    animation: labelFadeOut .2s forwards;\n}\n\n@keyframes linkHover {\n    0% {\n        background-color: inherit;\n        color: white;\n    }\n    100% {\n        background-color: #40154188;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: .8;\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes labelFadeIn {\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes labelFadeOut {\n    100% {\n        opacity: var(--defaultLinkOpacity);\n    }\n}\n\n@media (max-width: 500px) {\n    header {\n        padding-bottom: .5rem;\n    }\n\n    #links {\n        width: 95%;\n\n        .link-label {\n            max-width: 65%;\n            line-height: 120%;\n            text-align: right;\n            align-self: flex-end;\n            margin-left: -.5rem;\n            margin-right: .5rem;\n        }\n    }\n\n    #about {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    #hatemail {\n        align-self: center;\n        margin-top: -2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
